import cn from 'clsx';

import Icon from '../../Icon';

import s from './Status.module.scss';

export type StatusType = 'collecting' | 'abnormal' | 'normal' | 'primary' | 'new';
export interface StatusBadgeProps {
  type: StatusType;
  isIcon?: boolean;
  text?: string;
}

function Status({ type, text = '정상', isIcon = false }: StatusBadgeProps) {
  switch (type) {
    case 'collecting':
      return (
        <span className={cn(s.outer, s[type])}>
          <span className={s.text}>{text}</span>
        </span>
      );
    case 'abnormal':
      return (
        <span className={cn(s.outer, s[type])}>
          {isIcon && (
            <span className={cn(s.icon)}>
              <Icon type="state-error-solid" size={16} />
            </span>
          )}
          <span className={s.text}>{text}</span>
        </span>
      );
    case 'normal':
      return (
        <span className={cn(s.outer, s[type])}>
          {isIcon && (
            <span className={cn(s.icon)}>
              <Icon type="check-solid" size={16} />
            </span>
          )}
          <span className={s.text}>{text}</span>
        </span>
      );
    case 'primary':
      return (
        <span className={cn(s.outer, s[type])}>
          {isIcon && (
            <span className={cn(s.icon)}>
              <Icon type="check-solid" size={16} />
            </span>
          )}
          <span className={s.text}>{text}</span>
        </span>
      );
    case 'new':
      return (
        <span className={cn(s.outer, s[type])}>
          <span>NEW</span>
        </span>
      );
    default:
      return null;
  }
}

export default Status;
